/**
 * First we will load all of this project's JavaScript custom code.
 */

require('../../../../Src/bootstrap');

/**
 * Second we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import MemberRegister from './MemberRegister';

import { createApp } from "vue";
import Translations from '../../../Plugins/Localization/Translations';
import Toast from '../../../Plugins/Notification/Toast';
import Forms from '../../../Plugins/Forms/Forms';
import Dates from '../../../Plugins/Dates/Dates';
import Router from '../../../Plugins/Router/Router';

const app = createApp(MemberRegister);

app.config.unwrapInjectedRef = true;

/**
 * Plugins
 */
app.use(Translations);
app.use(Toast);
app.use(Forms);
app.use(Dates);
app.use(Router, {
    baseUrl: window.baseUrl
});

app.mount("#app");